"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PhoneField", {
  enumerable: true,
  get: function get() {
    return _PhoneField.default;
  }
});
Object.defineProperty(exports, "ButtonLoader", {
  enumerable: true,
  get: function get() {
    return _Loader.ButtonLoader;
  }
});
Object.defineProperty(exports, "ModalContainer", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
exports.LoginSignUp = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PhoneField = _interopRequireDefault(require("./components/PhoneField"));

var _Loader = require("./components/Loader");

var _Modal = _interopRequireDefault(require("./components/Modal"));

var _Login = _interopRequireDefault(require("./components/Login"));

var _SignUp = _interopRequireDefault(require("./components/SignUp"));

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LoginSignUp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginSignUp, _React$Component);

  function LoginSignUp(props) {
    var _this;

    _classCallCheck(this, LoginSignUp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoginSignUp).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "signUp", function () {
      _this.setState(function (prev) {
        return {
          signup: !prev.signup
        };
      });
    });

    _this.state = {
      signup: false
    };
    return _this;
  }

  _createClass(LoginSignUp, [{
    key: "render",
    value: function render() {
      var signup = this.state.signup;
      var _this$props = this.props,
          onSuccess = _this$props.onSuccess,
          heading = _this$props.heading;

      if (signup) {
        return _react.default.createElement("div", {
          className: _baseModule.default.outerContainer
        }, _react.default.createElement(_SignUp.default, {
          login: this.signUp,
          onSuccess: onSuccess,
          heading: heading
        }));
      }

      return _react.default.createElement("div", {
        className: _baseModule.default.outerContainer
      }, _react.default.createElement(_Login.default, {
        signUp: this.signUp,
        onSuccess: onSuccess,
        heading: heading,
        switchToOTP: this.renderOTP
      }));
    }
  }]);

  return LoginSignUp;
}(_react.default.Component);

exports.LoginSignUp = LoginSignUp;
LoginSignUp.propTypes = {
  heading: _propTypes.default.string,
  onSuccess: _propTypes.default.func.isRequired,
  baseURL: _propTypes.default.string
};